import { authRepo } from '../repo';

export const authService = {
    async login(credentials) {
        try {
            const response = await authRepo.login(credentials);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async register(data) {
        try {
            const response = await authRepo.register(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async logout() {
        try {
            const response = await authRepo.logout();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async me() {
        try {
            const response = await authRepo.me();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async refresh() {
        try {
            const response = await authRepo.refresh();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async changePassword(data) {
        try {
            const response = await authRepo.changePassword(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async forgotPassword(data) {
        try {
            const response = await authRepo.forgotPassword(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async verifyOtp(data) {
        try {
            return await authRepo.verifyOtp(data);
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async resetPassword(data) {
        try {
            const response = await authRepo.resetPassword(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('AuthService Error:', error);
        return error.response?.data || error;
    },
};